import { takeLatest } from 'redux-saga/effects';
import { fetchEntitySpawn } from 'store/saga';
import URLHelper from './lms.api';
import {
  FETCH_LEADS,
  fetchLeads,
  FETCH_FILTERS_CONFIG,
  fetchFiltersConfig,
  FETCH_LEAD_CONFIG,
  fetchLeadConfig,
  FETCH_LEAD_INFO,
  fetchLeadInfo,
  UPDATE_LEAD,
  updateLead,
  LEAD_EXOTEL,
  leadExotel,
  updateHotLead,
  UPDATE_HOT_LEAD,
} from './lms.actions';
import { REQUEST } from 'utils/actionGenerator';

function* getLeadsSaga(action) {
  const request = URLHelper.getLeads(action.params);
  yield fetchEntitySpawn(request, fetchLeads, action.params);
}

function* getFiltersData() {
  const request = URLHelper.getLeadsFilters();
  yield fetchEntitySpawn(request, fetchFiltersConfig);
}

function* getLeadConfig() {
  const request = URLHelper.getLeadConfig();
  yield fetchEntitySpawn(request, fetchLeadConfig);
}

function* getLeadInfo(action) {
  const request = URLHelper.getLeadInfo(action.params);
  yield fetchEntitySpawn(request, fetchLeadInfo);
}

function* updateLeadRequest(action) {
  const request = URLHelper.updateLead(action.params);
  yield fetchEntitySpawn(request, updateLead, {
    toaster: { successMsg: 'Lead updated successfully' },
  });
}

function* leadExotelCall(action) {
  const request = URLHelper.leadExotel(action.params);
  yield fetchEntitySpawn(request, leadExotel, {
    toaster: { successMsg: 'Successful', errorMsg: 'Something went wrong' },
  });
}

function* updateHotLeadRequest(action) {
  const request = URLHelper.updateHotLead(action.params);
  yield fetchEntitySpawn(request, updateHotLead, {
    toaster: { successMsg: 'Lead Status Updated successfully' },
  });
}

function* LeadsSaga() {
  yield takeLatest(FETCH_LEADS[REQUEST], getLeadsSaga);
  yield takeLatest(FETCH_FILTERS_CONFIG[REQUEST], getFiltersData);
  yield takeLatest(FETCH_LEAD_CONFIG[REQUEST], getLeadConfig);
  yield takeLatest(FETCH_LEAD_INFO[REQUEST], getLeadInfo);
  yield takeLatest(UPDATE_LEAD[REQUEST], updateLeadRequest);
  yield takeLatest(LEAD_EXOTEL[REQUEST], leadExotelCall);
  yield takeLatest(UPDATE_HOT_LEAD[REQUEST], updateHotLeadRequest);
}

export default LeadsSaga;
